module.exports = __webpack_public_path__ + "img/add.90a90f9f.png";